import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ClaimRepContactCardInfoRedacted } from "@modules/core-ui-extensions/models";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "cla-claim-summary-header-data",
  templateUrl: "claim-summary-header-data.component.html",
  styleUrls: ["./claim-summary-header-data.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ClaimSummaryHeaderDataComponent {
  @Input() isLoading: boolean;
  @Input() isFileOwnerLoading: boolean;
  @Input() headerData: { [key: string]: string };
  @Input() ownerRepCode: string;
  @Input() ownerRepSummary?: ClaimRepContactCardInfoRedacted;
  private copyClaimNumberClickedSubject$ = new BehaviorSubject(false);

  get copyNumberButtonClicked$() {
    return this.copyClaimNumberClickedSubject$.asObservable();
  }

  copyClaimNumberClick() {
    this.copyClaimNumberClickedSubject$.next(true);
    setTimeout(() => {
      this.copyClaimNumberClickedSubject$.next(false);
    }, 3000);
  }
}
